import { treeConfig,treeTools } from './tree-store'
let tree;
treeConfig.subscribe(prop => {
    tree = prop
})
export const setToolTree = (layer,key, value) => {
    treeTools.update(prop => {
		let find=prop.find(item =>item.layer===layer)
		if(find!==undefined){
			//find['key']=value
			prop.forEach(item => {
				if(key==='identify' || key==='config'){
					item[key]=false
				}
				if(item['layer']===layer){
					item[key]=value
				}
			})
		}else{
			let properties={
				layer,
				identify:false,
				config:false,
				opacity:100,
				name:layer,
				annio:'',
				group:''
			}
			console.log(key,'key...')
			properties[key]=value
			prop.push(properties)
		}
        //prop[0][key] = value
        return prop
    })
    return
}
export const setConfigTree = (id, properti,value) => {
    treeConfig.update(prop => {
		prop.forEach(item => {
			if (Array.isArray(item.children)) {
				item.children.forEach(item => {
                    item.children.forEach(item => {
						if(item['layer']===id){
							item[properti]=value
						}
                    })
				})
			}
		});
        return prop
    })
    return
}
export const getConfigTree = (id,properti) => {
	let result=''
	tree.forEach(item => {
			if (Array.isArray(item.children)) {
				item.children.forEach(item => {
                    item.children.forEach(item => {
						if(item['layer']===id){
							result=item[properti]
						}
                    })
				})
			}
		});
	return result
}